import { useNavigate } from "react-router-dom";

import {
  FooterMain,
  FooterMainFirst,
  FooterMainSecond,
  FooterMainThird,
  MainLogoInverted,
  MainPoweredByLogo,
  AccountIcon,
  FacebookIcon,
  TwitterIcon,
  LinkedInIcon,
} from "../StyledComponents/AppStyles";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <FooterMain>
      <div>
        <FooterMainFirst>
          <div>
            <div>
              <MainLogoInverted />
            </div>
            <div>
              <MainPoweredByLogo />
            </div>
          </div>
          <span>
            <p>
              This website and all of its contents are entirely fictitious and
              exist for demonstrational purposes only. Indicio does not provide
              insurance or banking services.
            </p>
            <p>Copyright © 2024 Indicio. All rights reserved.</p>
          </span>
        </FooterMainFirst>
        <FooterMainSecond>
          <div>
            <div>
              <p>Insurance</p>
              <span></span>
            </div>
            <a href="/">Automotive & Vehicle</a>
            <a href="/">Home Owners & Renters</a>
            <a href="/">Financial & Theft</a>
            <a href="/">Property Insurance</a>
            <a href="/">Life Insurance</a>
          </div>
          <div>
            <div>
              <p>Rentals</p>
              <span></span>
            </div>
            <a href="/">Car Rentals</a>
            <a href="/">Motorcycle Rentals</a>
            <a href="/">Boat Rentals</a>
            <a href="/">Other Rentals</a>
          </div>
          <div>
            <div>
              <p>Resources</p>
              <span></span>
            </div>
            <a href="/">Insurance 101</a>
            <a href="/">Choosing a Package</a>
            <a href="/">Cost Calculator</a>
          </div>
          <div>
            <div>
              <p>About Us</p>
              <span></span>
            </div>
            <a href="/">Our Story</a>
            <a href="/">Our Mission</a>
            <a href="/">Heraldic Is Giving Back</a>
            <a href="/">Privacy Policy</a>
            <a href="/">Cookie Policy</a>
          </div>
        </FooterMainSecond>
        <FooterMainThird>
          <div>
            <button>
              <span>
                <AccountIcon />
                <p>Log In</p>
              </span>
            </button>
            <button onClick={() => window.location.href = "https://indicio.tech/contact/"}>Contact Us</button>
          </div>
          <div>
            <p>Follow Us</p>
            <span>
              <TwitterIcon />
              <FacebookIcon />
              <LinkedInIcon />
            </span>
          </div>
        </FooterMainThird>
      </div>
    </FooterMain>
  );
}
